import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "d-flex justify-space-between w-100" }
const _hoisted_2 = { class: "d-flex justify-space-between align-center ga-2" }


export default /*@__PURE__*/_defineComponent({
  __name: 'CollectionMenu',
  setup(__props) {


const ui = useUiStore()
const collections = useCollectionsStore()
const { hasSelection, selection, favorites } = storeToRefs(collections)

const menuOpenStatus = ref(false)
const menuLocation = computed(() => ui.mobile ? 'top' : 'bottom')
const buttonColor = computed(() => ui.mobile ? 'primary' : 'white')
const buttonSize = computed(() => ui.mobile ? 'x-small' : 'default')
const processPrompt = computed(() => {
  return collections.processingSelection ? '' : 'Select a Process'
})
const processButtonType = computed(() => {
  return collections.processingSelection.startsWith('save') ? 'Save' : 'Process'
})

function buttonIcon(isActive: boolean) {
  if (hasSelection.value) {
    return isActive ? 'Selection' : 'SelectionO'
  } else {
    return isActive ? 'Favorites' : 'FavoritesO'
   }
}

function sort(collection: any[]) {
  return collection.sort((a: any, b: any) => {
    return a.name.localeCompare(b.name)
  })
}

const orderedCollection = computed(() => {
  const items = toValue(hasSelection.value ? selection.value.models : favorites.value.models)
  return sort(items)
})

function toggleMenu() {
  menuOpenStatus.value = !menuOpenStatus.value
}

function handleClearSelection() {
  collections.clearSelection()
}

function handleUnloadSelection() {
  collections.unloadSelection()
}

function handleProcessSelection() {
  if (collections.processingSelection === 'bulk-update') {
    navigateTo({ name: 'startups-bulk-update' })
  } else if (collections.processingSelection === 'save-as-collection') {
    collections.saveAsCollection()
  } else {
    collections.processDialog.open()
  }
  menuOpenStatus.value = false
}


return (_ctx: any,_cache: any) => {
  const _component_hy_icon = _resolveComponent("hy-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_CollectionFavorites = _resolveComponent("CollectionFavorites")!
  const _component_CollectionSubmenu = _resolveComponent("CollectionSubmenu")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_hy_button = _resolveComponent("hy-button")!
  const _component_v_list_subheader = _resolveComponent("v-list-subheader")!
  const _component_CollectionSelection = _resolveComponent("CollectionSelection")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_CollectionProcessingCompanyUpdates = _resolveComponent("CollectionProcessingCompanyUpdates")!
  const _component_CollectionProcessingShowcase = _resolveComponent("CollectionProcessingShowcase")!
  const _component_CollectionCreateDialog = _resolveComponent("CollectionCreateDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_btn, {
      id: "collection-menu-activator",
      variant: "tonal",
      color: _unref(buttonColor),
      size: _unref(buttonSize),
      icon: "",
      onClick: toggleMenu
    }, {
      default: _withCtx(() => [
        _createVNode(_component_hy_icon, {
          name: buttonIcon(_unref(menuOpenStatus)),
          small: _ctx.$ui.mobile
        }, null, 8, ["name", "small"])
      ]),
      _: 1
    }, 8, ["color", "size"]),
    _createVNode(_component_v_menu, {
      modelValue: _unref(menuOpenStatus),
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(menuOpenStatus) ? (menuOpenStatus).value = $event : null)),
      target: "#collection-menu-activator",
      location: _unref(menuLocation),
      "close-on-content-click": false
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_list, {
          "min-width": _ctx.$ui.mobile ? 250 : 400,
          rounded: "lg"
        }, {
          default: _withCtx(() => [
            (_unref(hasSelection))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_v_list_item, {
                    title: "Collections",
                    "prepend-icon": "fas fa-layer-group",
                    to: { name: 'collections' }
                  }),
                  (_unref(collections).hasFavorites)
                    ? (_openBlock(), _createBlock(_component_CollectionSubmenu, {
                        key: 0,
                        title: "Favorites",
                        icon: "Favorites",
                        class: "mb-2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_CollectionFavorites)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_divider, { class: "mb-4" }),
                  _createVNode(_component_v_list_subheader, { style: {"display":"block"} }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("h3", null, _toDisplayString(_unref(collections).selectionName), 1),
                        (_unref(collections).isLoadedFromSelection)
                          ? (_openBlock(), _createBlock(_component_hy_button, {
                              key: 0,
                              type: "Clear",
                              onClick: handleClearSelection
                            }))
                          : (_openBlock(), _createBlock(_component_hy_button, {
                              key: 1,
                              type: "Clear",
                              name: "Unload",
                              onClick: handleUnloadSelection
                            }))
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_CollectionSelection),
                  _createVNode(_component_v_divider, { class: "my-2" }),
                  _createVNode(_component_v_list_item, null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_2, [
                        _createVNode(_component_v_select, {
                          modelValue: _unref(collections).processingSelection,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(collections).processingSelection) = $event)),
                          items: _unref(collections).processItems,
                          label: _unref(processPrompt),
                          variant: "solo-filled",
                          density: "compact",
                          "hide-details": ""
                        }, null, 8, ["modelValue", "items", "label"]),
                        _createVNode(_component_hy_button, {
                          type: _unref(processButtonType),
                          disabled: _unref(collections).processingSelection === '',
                          primary: "",
                          onClick: handleProcessSelection
                        }, null, 8, ["type", "disabled"])
                      ])
                    ]),
                    _: 1
                  })
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(_component_v_list_item, {
                    title: "Collections",
                    "prepend-icon": "fas fa-layer-group",
                    to: { name: 'collections' }
                  }),
                  (_unref(collections).hasFavorites)
                    ? (_openBlock(), _createBlock(_component_v_list_subheader, { key: 0 }, {
                        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                          _createTextVNode(" Favorites ", -1)
                        ]))]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_CollectionFavorites)
                ], 64))
          ]),
          _: 1
        }, 8, ["min-width"])
      ]),
      _: 1
    }, 8, ["modelValue", "location"]),
    (_unref(collections).processingSelection === 'company-updates')
      ? (_openBlock(), _createBlock(_component_CollectionProcessingCompanyUpdates, { key: 0 }))
      : _createCommentVNode("", true),
    (_unref(collections).processingSelection === 'showcase')
      ? (_openBlock(), _createBlock(_component_CollectionProcessingShowcase, { key: 1 }))
      : _createCommentVNode("", true),
    (_unref(collections).processingSelection === 'save-as-collection')
      ? (_openBlock(), _createBlock(_component_CollectionCreateDialog, { key: 2 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})